module.exports = __webpack_public_path__ + "static/img/application3.d20bd5b1.png";